// Storage primitives for the alpha allocation draft, kept in their own module so
// AuthContext can clear the draft on logout / user switch without importing
// AlphaAllocationDraftContext (which imports AuthContext -- a cycle).
//
// The key is user-scoped: an unscoped key let one investor's pending draft be
// read by the next investor signing in on the same device, and a stored draft
// takes precedence over freshly-fetched server rows.

const SESSION_KEY_PREFIX = "alpha-allocation-draft";

export const alphaAllocationDraftStorageKey = (userId: string): string =>
  `${SESSION_KEY_PREFIX}:${userId}`;

export function clearAlphaAllocationDraft(userId: string | null): void {
  if (!userId) return;
  try {
    sessionStorage.removeItem(alphaAllocationDraftStorageKey(userId));
  } catch {
    // Storage cleanup is best effort.
  }
}
